<template >
  <div class="appRight"><router-view name="b"></router-view></div>
</template>
<script>
export default {
  name: "AppRight",
};
</script>
<style lang="">
</style>